import { createHandlerChainRunner, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { BranchModel, getBranches } from "@WhiteCap/Services/ContactUsLocationsService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<{}, { branches: BranchModel[] }> & HasOnComplete;

export const DispatchBeginLoadBranches: HandlerType = props => {
    props.dispatch({
        type: "Custom/Branches/BeginLoadBranches",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {};
};

export const RequestBranchesFromApi: HandlerType = async props => {
    try {
        const response = await getBranches(props.apiParameter);

        props.apiResult = {
            branches: response || [],
        };
    } catch (error) {
        props.dispatch({
            type: "Custom/Branches/FailedLoadBranches",
        });
    }
};

export const DispatchCompleteLoadBranches: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }

    props.dispatch({
        type: "Custom/Branches/CompleteLoadBranches",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginLoadBranches,
    PopulateApiParameter,
    RequestBranchesFromApi,
    DispatchCompleteLoadBranches,
];

const loadBranches = createHandlerChainRunner(chain, "LoadBranches");

export default loadBranches;
